import React from 'react'
import { ButtonCta, ButtonCtaProps, ButtonStatus } from '../../../ui-lib/button'

type NotAvailableButtonProps = Omit<ButtonCtaProps, 'text'>

export const NotAvailableButton: React.FC<NotAvailableButtonProps> = (props) => {
  return <ButtonCta {...props} status={ButtonStatus.Disabled} text="Not Available" />
}
